export const getFileExtensionFromUrl = (url: string) => {
  return url.split(".").pop() || "";
};
